import React from "react";
import "./estilos/ModalConfirm.css";
import loadingGif from "./assets/loading.gif";

const ConfirmModal = ({
  message,
  onConfirm,
  onCancel,
  isLoading,
  isCompleted,
}) => {
  return (
    <div className="modal-overlay">
      {isLoading ? (
        <div className="modal-content">
          <p>{message}</p>
          <img src={loadingGif} width="50px" />
        </div>
      ) : !isCompleted ? (
        <div className="modal-content">
          <p>{message}</p>

          <div className="modal-buttons">
            <button className="cancel" onClick={onCancel}>
              Cancelar
            </button>
            <button className="confirm" onClick={onConfirm}>
              Confirmar
            </button>
          </div>
        </div>
      ) : (
        <div className="modal-content">
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default ConfirmModal;
